<template>
  <div class="order-page-buttons" :class="{ visible }">
    <div class="buttons c:row-center" ref="container">
      <template v-if="canPay">
        <CButton
          primary
          :disabled="
            !paymentPrivacyChecked || (isBaseOrder && !deliveryFormValidated)
          "
          :loading="submiting"
          @click="onPayInFullButtonClick"
          >去支付</CButton
        >
      </template>
      <CButton
        v-else-if="canApplyBill"
        :loading="submiting"
        @click="onApplyBillButtonClick"
        >申请发票</CButton
      >
      <CButton
        v-if="order.status === 20"
        primary
        :disabled="!deliveryFormValidated"
        :loading="submiting"
        @click="onResetDeliveryButtonClick"
        >确定</CButton
      >
      <CButton
        v-else-if="order.status === 40"
        primary
        :loading="loading"
        @click="onShowQRCodeButtonClick"
        >面对面收货</CButton
      >
      <CButton
        v-else-if="order.status === 50"
        primary
        :loading="submiting"
        @click="onReceivedButtonClick"
        >确认收货</CButton
      >
    </div>
    <CBottomPad />
    <QrCodePopup ref="refQrCodePopup" />
  </div>
</template>

<script>
import CButton from "@/components/common/CButton.vue";
import QrCodePopup from "../popups/QrCodePopup.vue";
import CBottomPad from "@/components/common/CBottomPad.vue";

export default {
  components: { CButton, CBottomPad, QrCodePopup },
  props: {
    order: Object,
    isBaseOrder: Boolean,
    canPay: Boolean,
    canSplitPay: Boolean,
    canApplyBill: Boolean,
    paymentPrivacyChecked: Boolean,
    deliveryFormValidated: Boolean,
    submiting: Boolean,
  },
  data() {
    return {
      visible: false,
      loading: false,
      showQrModal: false,
      code: "",
    };
  },
  watch: {
    "order.status": {
      deep: true,
      handler(status) {
        if (status !== 40) {
          this.$refs.refQrCodePopup.hide();
        }
        this.$nextTick().then(() => this.checkVisibility());
      },
    },
  },
  mounted() {
    this.checkVisibility();
  },
  methods: {
    checkVisibility() {
      if (this.$refs.container && this.$refs.container.innerHTML) {
        this.visible = this.$refs.container.innerHTML.includes("<div");
      } else {
        this.visible = false;
      }
    },
    onPayByInstallmentsButtonClick() {
      this.$emit("paybyinstallments");
    },
    onPayInFullButtonClick() {
      this.$emit("payinfull");
    },
    onResetDeliveryButtonClick() {
      this.$emit("resetdelivery", true);
    },
    onApplyBillButtonClick() {
      this.$emit("applybill");
    },
    async onShowQRCodeButtonClick() {
      if (this.order.status === 40) {
        this.$emit("showqrcode");
        await this.$refs.refQrCodePopup.show(this.order.id);
        this.$emit("hideqrcode");
      }
    },
    onQRCodeModalClose() {
      console.log("closed");
      this.timer2 && clearInterval(this.timer2);
      this.timer && clearInterval(this.timer);
    },
    onReceivedButtonClick() {
      this.$emit("received");
    },
  },
};
</script>

<style lang="less" scoped>
.order-page-buttons {
  position: fixed;
  width: 100%;
  height: auto;
  bottom: 0;
  z-index: 200;

  &.visible {
    background-color: #fff;
    box-shadow: 0px -2px 5px 0px #00000017;
  }

  .buttons {
    gap: 12/20rem;

    box-sizing: border-box;
    padding: 8/20rem 20/20rem;
  }
}
</style>
